// extracted by mini-css-extract-plugin
module.exports = {"errorText":"CreateArchive_errorText__3w9Lt","pendingMessage":"CreateArchive_pendingMessage__KD70k","container":"CreateArchive_container__1dEis"};